import axios from 'axios';
import Cookies from 'js-cookie';

const { apiHost = '' } = window.osdeskConfig || {};
const wootAPI = axios.create({ baseURL: `${apiHost}/` });

wootAPI.interceptors.request.use(config => {
  const sessionInfo = Cookies.get('cw_d_session_info');
  if (sessionInfo) {
    try {
      const authData = JSON.parse(sessionInfo);
      config.headers['access-token'] = authData['access-token'];
      config.headers['token-type'] = authData['token-type'] || 'Bearer';
      config.headers.client = authData.client;
      config.headers.expiry = authData.expiry;
      config.headers.uid = authData.uid;
    } catch (e) {
      console.warn('Failed to parse auth cookie:', e);
    }
  }

  if (config.url) {
    if (config.url.startsWith('/api/v1/')) {
      config.url = config.url.replace('/api/v1/', '/api/v1/osdesk/');
    } else if (config.url.startsWith('api/v1/')) {
      config.url = config.url.replace('api/v1/', 'api/v1/osdesk/');
    }
  }
  return config;
});

export default wootAPI;
